import { render, staticRenderFns } from "./ScheduleSettingsTab.vue?vue&type=template&id=87bb7e9a&scoped=true"
import script from "./ScheduleSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ScheduleSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./ScheduleSettingsTab.vue?vue&type=style&index=0&id=87bb7e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb7e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCol,VDivider,VForm,VIcon,VRow,VTextField})
